import axiosClient from 'config/axiosClient';

const _url = '/Api/SubjectSpecial';

const subjectSpecialService = {
    save: (options) => {
        return axiosClient.post(_url + '/Save', options);
    },
    getPaging: (options) => {
        return axiosClient.post(_url + '/GetPaging', options);
    },
    getPagingSubject: (options) => {
        return axiosClient.post(_url + '/GetPagingSubject', options);
    },
    delete: (options) => {
        return axiosClient.post(_url + '/Delete', options);
    }
};

export default subjectSpecialService;